<template>
  <div class="fixed inset-0 z-40 bg-black/30 flex items-center justify-center" @click.self="$emit('close')">
    <div class="bg-white rounded-lg border border-gray-200 w-[48rem] max-w-[95vw] max-h-[80vh] flex flex-col">
      <div class="px-4 py-3 border-b border-gray-100 flex items-center gap-3 shrink-0">
        <h3 class="text-sm font-semibold text-gray-900">Warehouse tables the agent may query</h3>
        <span v-if="tableCount" class="text-xs text-gray-600">{{ tableCount }}</span>
        <input
          v-model.trim="search"
          type="text"
          placeholder="Search tables…"
          class="ml-auto border border-gray-200 rounded px-2 py-1 text-xs w-56 focus:outline-none focus:border-gray-400"
        />
        <button class="text-gray-400 hover:text-gray-600" @click="$emit('close')">×</button>
      </div>
      <div class="p-4 overflow-y-auto flex-1">
        <p v-if="loading" class="text-xs text-gray-600">Loading catalog…</p>
        <p v-else-if="!schemas.length" class="text-xs text-gray-600">Catalog unavailable.</p>
        <div v-for="schema in filtered" :key="schema.name" class="mb-4">
          <p class="text-[11px] font-semibold text-gray-600 uppercase tracking-wide mb-1">
            {{ schema.name }} <span class="font-normal text-gray-400">{{ schema.tables.length }}</span>
          </p>
          <div class="border border-gray-50 rounded">
            <div
              v-for="t in schema.tables"
              :key="t.name"
              class="px-3 py-1.5 border-b border-gray-50 last:border-b-0 flex items-baseline gap-3"
            >
              <span class="text-xs font-mono text-gray-800 shrink-0">{{ t.name }}</span>
              <span class="text-[11px] text-gray-600 truncate">{{ t.description }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AgentTablesModal',
  emits: ['close'],
  data() {
    return { schemas: [], loading: true, search: '' };
  },
  computed: {
    tableCount() {
      return this.schemas.reduce((n, s) => n + s.tables.length, 0);
    },
    filtered() {
      const q = this.search.toLowerCase();
      if (!q) return this.schemas;
      return this.schemas
        .map((s) => ({
          name: s.name,
          tables: s.tables.filter((t) => t.name.toLowerCase().includes(q)
            || (t.description || '').toLowerCase().includes(q)),
        }))
        .filter((s) => s.tables.length);
    },
  },
  async mounted() {
    try {
      const { data } = await axios.get('/api/impact_analytics/warehouse-catalog/');
      this.schemas = (data.schemas || [])
        .map((s) => ({
          name: s.name,
          tables: Object.entries(s.tables || {})
            .filter(([, t]) => t.use_for_metrics)
            .map(([name, t]) => ({ name, description: t.description || '' })),
        }))
        .filter((s) => s.tables.length);
    } catch {
      this.schemas = [];
    }
    this.loading = false;
  },
};
</script>
